import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { agencyApi } from '../api/agencyApi';
import { agencyKeys } from '../queryKeys';

/** How many practices one admin can keep at the top of the table. Mirrors the backend cap. */
export const PINNED_PRACTICES_MAX = 3;

export function usePinnedPractices() {
  return useQuery({
    queryKey: agencyKeys.pinnedPractices(),
    queryFn: () => agencyApi.getPinnedPractices(),
    staleTime: 5 * 60_000,
  });
}

/** Pin or unpin one practice. The server holds the list, so the whole list is sent each time. */
export function useTogglePinnedPractice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ practiceId, pinned }: { practiceId: string; pinned: boolean }) => {
      const current =
        queryClient.getQueryData<string[]>(agencyKeys.pinnedPractices()) ??
        (await agencyApi.getPinnedPractices());
      const next = pinned
        ? [...current.filter((id) => id !== practiceId), practiceId]
        : current.filter((id) => id !== practiceId);
      return agencyApi.setPinnedPractices(next);
    },
    onSuccess: (pins) => queryClient.setQueryData(agencyKeys.pinnedPractices(), pins),
  });
}
